module.exports = __webpack_public_path__ + "3351ff8f8141afc23be3e9152caef1bd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-6.png
// module id = 2477
// module chunks = 0